import { TCanvasLink } from "../types/TCanvasLink";
import { TCanvasNode } from "../types/TCanvasNode";
import { TCanvasOptions } from "../types/TCanvasOptions";
// import { TCanvasOptions } from "../types/TCanvasOptions";
// import { TCatalog } from "../types/TCatalog";
// import { TLink } from "../types/TLink";
import createLinkId from "./createLinkId";
// import createNodeId from "./createNodeId";

function getAncestorId(
  nodesById: { [k: string]: TCanvasNode },
  renderNodesById: { [k: string]: TCanvasNode },
  node_id: string | TCanvasNode | null,
  granularity?: number
): string | null {
  if (node_id == null) return node_id;
  if (typeof node_id == "object") return node_id.node_id
  if(granularity != undefined && granularity < 2) {
    while (node_id && renderNodesById[node_id] == undefined) {
      if(nodesById[node_id] == undefined) {
        node_id = null
      } else {
        node_id = nodesById[node_id].parent_node_id ?? null
      }
    }
  }
  return node_id
}

function isInAccurancyRange(value: number, minAccuracy: number, maxAccuracy: number): boolean {
    return value >= minAccuracy &&  value <= maxAccuracy
}


export default function updateLinks(
  nodesById: { [k: string]: TCanvasNode },
  foreignLinksById: { [k: string]: TCanvasLink },
  connectionsById: { [k: string]: number },
  renderNodesById: { [k: string]: TCanvasNode },
  canvasOptions: TCanvasOptions | null
): TCanvasLink[] {
  const newLinks: TCanvasLink[] = [];

  Object.entries(renderNodesById).forEach((entry) => {
    const key = entry[0];
    const renderNodeItem = entry[1];
    if (
      renderNodeItem.parent_node_id &&
      renderNodesById[renderNodeItem.parent_node_id]
    ) {
      let temp: TCanvasLink = {
        id: newLinks.length,
        link_type: `heirarchical_${renderNodeItem.node_type.toLowerCase()}`,
        source: renderNodeItem.parent_node_id,
        target: key,
        accuracy: 100,
      }
      if (renderNodeItem.node_type == 'OTHER') {
        temp = {
          id: newLinks.length,
          link_type: `heirarchical_column`,
          source: renderNodeItem.parent_node_id,
          target: key,
          accuracy: 100,
        }
      }
      newLinks.push(temp);
    } else if (renderNodeItem.node_type == "TABLE") {
      let tmp: TCanvasLink = {
        id: newLinks.length,
        link_type: `heirarchical_${renderNodeItem.node_type.toLowerCase()}`,
        source: "__DEFAULT_DOMAIN__",
        target: key,
        accuracy: 100,
      } 
      newLinks.push(tmp)
    }
  });


  const newForeignLinksById: { [k: string]: TCanvasLink } = {}
  const { minAccuracy, granularity, maxAccuracy } = canvasOptions ?? {
    searchText: "",
    minAccuracy: 60,
    maxAccuracy: 100
  }

  // // inserting foreign links
  Object.entries(foreignLinksById).forEach(entry => {
    // const key = entry[0]
    const foreignLink = entry[1]
    const source_node_id = getAncestorId(nodesById, renderNodesById, foreignLink.source, granularity)
    const target_node_id = getAncestorId(nodesById, renderNodesById, foreignLink.target, granularity)
    if (
      source_node_id &&
      renderNodesById[source_node_id] &&
      target_node_id &&
      renderNodesById[target_node_id]
    ) {

      const item_key = createLinkId(source_node_id, target_node_id)
      if(foreignLink.accuracy == undefined) {
      } else if(!isInAccurancyRange(foreignLink.accuracy, minAccuracy, maxAccuracy)) {
        return;
      }
      if (newForeignLinksById[item_key]) {
        newForeignLinksById[item_key] = {
          ...newForeignLinksById[item_key],
          payload:
            [
              ...(newForeignLinksById[item_key].payload ?? []),
              {
                source_connections: typeof foreignLink.source == "object" ? foreignLink.source.connections : undefined,
                target_connections: typeof foreignLink.target == "object" ? foreignLink.target.connections : undefined,
                records_mapped: foreignLink.payload?.length ? foreignLink.payload[0].records_mapped : 0,
                source_col: foreignLink.source,
                target_col: foreignLink.target,
                link_id: foreignLink.id
              }
            ]
        }
      } else {
        newForeignLinksById[item_key] = {
          link_type: 'foreign',
          id: newLinks.length,
          source: source_node_id,
          target: target_node_id,
          payload: [{
            source_connections: typeof foreignLink.source == "string" ? connectionsById[foreignLink.source] : undefined,
            target_connections: typeof foreignLink.target == "string" ? connectionsById[foreignLink.target] : undefined,
            records_mapped: foreignLink.payload?.length ? foreignLink.payload[0].records_mapped : 0,
            source_col: foreignLink.source,
            target_col: foreignLink.target,
            link_id: foreignLink.id
          }],
          accuracy: foreignLink.accuracy
        }
      }

      renderNodesById[source_node_id].links = [...renderNodesById[source_node_id].links ?? [], newForeignLinksById[item_key]]
      renderNodesById[target_node_id].links = [...renderNodesById[target_node_id].links ?? [], newForeignLinksById[item_key]]
    }
  })

  for (const [_, value] of Object.entries(newForeignLinksById)) {
    newLinks.push(value)
  }

  // newLinks.push()

  return newLinks;
}
